import React, { useState } from 'react';

import { Grid, TextField } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { ButtonComponent, CardComponent } from 'components';
import { MigrationReportRunParams } from 'types';

interface RunReportFormProps {
  onRun: (params: MigrationReportRunParams) => Promise<unknown>;
}

export const RunReportForm = ({ onRun }: RunReportFormProps) => {
  const { t } = useTranslation();

  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [loading, setLoading] = useState(false);

  const handleRun = () => {
    setLoading(true);
    onRun({ fromDate: fromDate || undefined, toDate: toDate || undefined }).finally(() => setLoading(false));
  };

  return (
    <CardComponent title={t('pages.migrationReports.run.title')} sm={12}>
      <Grid container spacing={4} direction="column">
        <Grid item>{t('pages.migrationReports.run.description')}</Grid>
        <Grid item container spacing={2} alignItems="center">
          <Grid item xs={12} sm={4} md={3}>
            <TextField
              id="migration-report-from-date"
              type="date"
              label={t('pages.migrationReports.run.fromDate')}
              value={fromDate}
              onChange={e => setFromDate(e.target.value)}
              variant="outlined"
              margin="dense"
              fullWidth
              InputLabelProps={{ shrink: true }}
              inputProps={{ max: toDate || undefined }}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={3}>
            <TextField
              id="migration-report-to-date"
              type="date"
              label={t('pages.migrationReports.run.toDate')}
              value={toDate}
              onChange={e => setToDate(e.target.value)}
              variant="outlined"
              margin="dense"
              fullWidth
              InputLabelProps={{ shrink: true }}
              inputProps={{ min: fromDate || undefined }}
            />
          </Grid>
          <Grid item>
            <ButtonComponent
              color="primary"
              text={t('pages.migrationReports.run.button')}
              loading={loading}
              onClick={handleRun}
            />
          </Grid>
        </Grid>
      </Grid>
    </CardComponent>
  );
};
